import React from 'react';
import { Badge, Button } from 'antd';
import { CustomerServiceOutlined } from '@ant-design/icons';
import { SidebarNavItem } from '../../pages/Home/styles';
import { useRegisterSupportEntry, useSupportPanel } from './SupportProvider';

/**
 * Sidebar entry into support. It opens the same panel as the floating button, and by registering
 * itself it is what makes hiding that button safe: no sidebar on screen, no hiding.
 */
export const SidebarSupportEntry: React.FC = () => {
  const { openPanel, unread } = useSupportPanel();
  useRegisterSupportEntry();

  return (
    <SidebarNavItem onClick={openPanel} data-testid="sidebar-support-entry">
      <CustomerServiceOutlined />
      <span className="nav-label">Technical Support</span>
      {unread > 0 && <Badge count={unread} size="small" />}
    </SidebarNavItem>
  );
};

/** The same entry for the collapsed rail. */
export const SidebarSupportRailButton: React.FC = () => {
  const { openPanel, unread } = useSupportPanel();
  useRegisterSupportEntry();

  return (
    <Badge count={unread} size="small" overflowCount={99} offset={[-4, 4]}>
      <Button
        type="text"
        icon={<CustomerServiceOutlined />}
        onClick={openPanel}
        aria-label={`Technical support${unread ? `, ${unread} unread` : ''}`}
        data-testid="sidebar-support-rail"
        style={{ color: '#848E9C', width: '36px', height: '36px' }}
      />
    </Badge>
  );
};
